import { TABLE, TD } from "@/components/tool-kit/styles";

/**
 * A table whose headers are mathematical symbols (f⁽ᵏ⁾(a), xₙ, f(xₙ)): the shared
 * `DataTable` upper-cases its headers, which turns f⁽ᵏ⁾(x) into F⁽ᵏ⁾(X). Cells are text.
 */
const TH_MATH =
  "whitespace-nowrap border-border border-b px-3 py-2 font-medium text-foreground text-xs [overflow-wrap:normal]";

export function MathTable({
  head,
  rows,
  caption,
  highlight,
}: {
  head: readonly string[];
  rows: readonly (readonly (string | number)[])[];
  caption?: string;
  /** Index of a row to emphasise (the final iterate, say). */
  highlight?: number;
}) {
  return (
    <div className="overflow-x-auto rounded-lg border border-border bg-card">
      <table className={TABLE}>
        {caption ? (
          <caption className="px-3 pt-3 text-left text-muted-foreground text-sm">
            {caption}
          </caption>
        ) : null}
        <thead>
          <tr>
            {head.map((cell) => (
              <th className={TH_MATH} key={cell} scope="col">
                {cell}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr
              className={rowIndex === highlight ? "bg-primary/5" : undefined}
              // Rows are positional data with no identity of their own.
              // biome-ignore lint/suspicious/noArrayIndexKey: positional rows
              key={rowIndex}
            >
              {row.map((cell, cellIndex) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: positional cells
                <td className={`${TD} font-mono tabular-nums`} key={cellIndex}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
